import {
  all, call, put, take,
} from 'redux-saga/effects';
import {
  forEach, getOr, map, orderBy,
} from 'lodash/fp';

import * as adminServices from '../admin/services';
import { FIREBASE_REF } from '../common/constants';
import * as errorActions from '../errors/actions';
import firebase from '../common/firebase';
import * as actions from './actions';

export function* fetchNewsletters() {
  while (true) {
    try {
      const action = yield take(actions.FETCH_NEWSLETTERS_REQUEST);

      const { sid } = action.payload;

      yield call(adminServices.fetchSchoolAdminRelationships, { sid });

      const ref = yield call(firebase.firestore.collection, `${FIREBASE_REF}/school-newsletters`);
      const snapshot = yield call(firebase.firestore.getCollection, ref.where('school', '==', sid).orderBy('createdAt', 'desc'));
      // TODO: Firestore 마이그레이션 이후 `status` 필드 수정 요망(`paused` => `status`)

      const newsletters = map(doc => ({
        id: doc.id,
        status: 'ongoing',
        writer: '-',
        ...doc.data(),
      }), snapshot.docs);
      yield put({
        type: actions.FETCH_NEWSLETTERS_SUCCESS,
        payload: { newsletters: orderBy(['status'], ['desc'], newsletters) },
      });
    } catch (error) {
      yield put({
        type: actions.FETCH_NEWSLETTERS_FAILURE,
        payload: { error },
      });

      yield put(errorActions.errorOccured({ error }));
    }
  }
}

export function* fetchTargetsByNewsletter() {
  while (true) {
    try {
      const action = yield take(actions.FETCH_TARGETS_BY_NEWSLETTER_REQUEST);

      const { nid, sid } = action.payload;

      yield call(adminServices.fetchSchoolAdminRelationships, { sid });

      const ref = yield call(firebase.firestore.doc, `${FIREBASE_REF}/targets/${nid}`);

      const doc = yield call(firebase.firestore.getDocument, ref);

      const targets = doc.exists ? doc.data() : null;

      yield put(actions.fetchTargetsByNewsletterSuccess({ targets: getOr(null, 'data', targets) }));
    } catch (error) {
      yield put(actions.fetchTargetsByNewsletterFailure({ error }));

      yield put(errorActions.errorOccured({ error }));
    }
  }
}

function* deleteNewsletterFile({ nid, sid }) {
  try {
    const ref = yield call(firebase.storage.ref, `${FIREBASE_REF}/schools/${sid}/school-newsletters/${nid}.pdf`);

    yield call(
      firebase.storage.delete,
      ref,
    );

    yield put(actions.deleteNewsletterFileSuccess());
  } catch (error) {
    yield put(actions.deleteNewsletterFileFailure({ error }));

    yield put(errorActions.errorOccured({ error }));
  }
}

// TODO: 한 번에 최대 가능한 배치 횟수를 넘겼을 경우에 대한 처리 (200회)
export function* deleteNewsletters() {
  while (true) {
    try {
      const action = yield take(actions.DELETE_NEWSLETTERS_REQUEST);

      const { nids, sid } = action.payload;

      yield call(adminServices.fetchSchoolAdminRelationships, { sid });

      const refs = yield all([...map(nid => call(
        firebase.firestore.doc,
        `${FIREBASE_REF}/school-newsletters/${nid}`,
      ), action.payload.nids), ...map(nid => call(
        firebase.firestore.doc,
        `${FIREBASE_REF}/surveys/${nid}`,
      ), action.payload.nids), ...map(nid => call(
        firebase.firestore.doc,
        `${FIREBASE_REF}/targets/${nid}`,
      ), action.payload.nids), ...map(nid => call(
        firebase.firestore.doc,
        `${FIREBASE_REF}/stats/${nid}`,
      ), action.payload.nids), ...map(nid => call(
        firebase.firestore.doc,
        `${FIREBASE_REF}/individuals/${nid}`,
      ), nids)]);

      const updateFunction = async (transaction) => {
        forEach(ref => transaction.delete(ref), refs);
      };

      yield call(firebase.firestore.runTransaction, updateFunction);

      yield all([
        ...map(nid => call(
          deleteNewsletterFile, { nid, sid: action.payload.sid },
        ), action.payload.nids),
      ]);

      yield put(actions.deleteNewslettersSuccess({ nids: action.payload.nids }));
    } catch (error) {
      yield put(actions.deleteNewslettersFailure({ error }));

      yield put(errorActions.errorOccured({ error }));
    }
  }
}
